// Auto-generated from custom_ad_properties_v2.json
// Maps category_id to its custom fields for use in AdForm
export const CUSTOM_AD_PROPERTIES = {
  3: [
    { name: "متراژ", type: "number" },
    { name: "تعداد اتاق", type: "select", options: ["1", "2", "3", "4+"] },
    { name: "طبقه", type: "number" },
    { name: "آسانسور", type: "switch" },
    { name: "پارکینگ", type: "switch" },
    { name: "انباری", type: "switch" }
  ],
  4: [
    { name: "متراژ", type: "number" },
    { name: "تعداد طبقات", type: "number" },
    { name: "پارکینگ", type: "switch" },
    { name: "حیاط", type: "switch" }
  ],
  6: [
    { name: "متراژ", type: "number" },
    { name: "تعداد اتاق", type: "select", options: ["1", "2", "3", "4+"] },
    { name: "طبقه", type: "number" },
    { name: "آسانسور", type: "switch" },
    { name: "پارکینگ", type: "switch" },
    { name: "انباری", type: "switch" }
  ],
  7: [
    { name: "متراژ", type: "number" },
    { name: "تعداد طبقات", type: "number" },
    { name: "پارکینگ", type: "switch" },
    { name: "حیاط", type: "switch" }
  ],
  8: [
    { name: "متراژ", type: "number" },
    { name: "نوع کاربری", type: "select", options: ["مسکونی", "تجاری", "کشاورزی", "اداری"] },
    { name: "دارای جواز ساخت", type: "switch" }
  ],
  10: [
    { name: "متراژ", type: "number" },
    { name: "تعداد اتاق", type: "number" },
    { name: "پارکینگ", type: "switch" },
    { name: "آسانسور", type: "switch" }
  ],
  11: [
    { name: "متراژ", type: "number" },
    { name: "تعداد بر", type: "number" },
    { name: "سند تجاری", type: "switch" }
  ],
  14: [
    { name: "متراژ", type: "number" },
    { name: "تعداد اتاق", type: "number" },
    { name: "پارکینگ", type: "switch" },
    { name: "آسانسور", type: "switch" }
  ],
  15: [
    { name: "متراژ", type: "number" },
    { name: "تعداد بر", type: "number" },
    { name: "سند تجاری", type: "switch" }
  ],
  19: [
    { name: "متراژ", type: "number" },
    { name: "تعداد اتاق", type: "number" },
    { name: "استخر", type: "switch" },
    { name: "محوطه‌سازی", type: "switch" }
  ],
  26: [
    { name: "برند", type: "select", options: ["پژو", "پراید", "سمند", "تیبا", "دنا"] },
    { name: "مدل", type: "text" },
    { name: "سال تولید", type: "number" },
    { name: "کارکرد", type: "number" },
    { name: "نوع سوخت", type: "select", options: ["بنزین", "دوگانه", "برقی"] },
    { name: "بیمه", type: "switch" }
  ],
  35: [
    { name: "برند", type: "select", options: ["Samsung", "Apple", "Xiaomi", "Huawei", "Nokia"] },
    { name: "مدل", type: "text" },
    { name: "ظرفیت حافظه", type: "select", options: ["64GB", "128GB", "256GB"] },
    { name: "RAM", type: "select", options: ["4GB", "6GB", "8GB"] },
    { name: "رنگ", type: "text" }
  ],
  36: [
    { name: "برند", type: "select", options: ["Apple", "Samsung", "Huawei", "Lenovo"] },
    { name: "مدل", type: "text" },
    { name: "اندازه صفحه نمایش", type: "text" },
    { name: "حافظه داخلی", type: "text" }
  ],
  40: [
    { name: "برند", type: "select", options: ["Asus", "HP", "Lenovo", "Apple", "Dell"] },
    { name: "مدل", type: "text" },
    { name: "CPU", type: "text" },
    { name: "RAM", type: "select", options: ["4GB", "8GB", "16GB", "32GB"] },
    { name: "اندازه صفحه نمایش", type: "select", options: ["13\"", "14\"", "15.6\"", "17\""] }
  ],
  44: [
    { name: "نوع", type: "select", options: ["پرینتر", "اسکنر", "کپی", "فکس", "چندکاره"] },
    { name: "برند", type: "text" }
  ],
  48: [
    { name: "نوع", type: "select", options: ["دیجیتال", "DSLR", "بدون آینه", "ورزشی"] },
    { name: "برند", type: "text" },
    { name: "رزولوشن", type: "text" }
  ],
  52: [
    { name: "نوع", type: "select", options: ["LED", "OLED", "QLED", "پروژکتور"] },
    { name: "اندازه", type: "text" },
    { name: "برند", type: "text" },
    { name: "اسمارت", type: "switch" }
  ],
  58: [
    { name: "نوع", type: "select", options: ["یخچال", "فریزر", "ساید بای ساید"] },
    { name: "برند", type: "text" },
    { name: "ظرفیت", type: "text" }
  ],
  60: [
    { name: "نوع", type: "select", options: ["لباسشویی", "خشک‌کن", "دوقلو"] },
    { name: "برند", type: "text" },
    { name: "ظرفیت", type: "text" }
  ],
  67: [
    { name: "نوع", type: "select", options: ["اجاق گاز", "ماکروویو", "توستر"] },
    { name: "برند", type: "text" }
  ],
  84: [
    { name: "تعداد نفرات", type: "select", options: ["2", "4", "6", "8", "12+"] },
    { name: "جنس", type: "text" },
    { name: "رنگ", type: "text" }
  ],
  86: [
    { name: "جنس", type: "text" },
    { name: "تعداد طبقات", type: "number" },
    { name: "رنگ", type: "text" }
  ],
  100: [
    { name: "ابعاد", type: "text" },
    { name: "جنس", type: "text" },
    { name: "طرح", type: "text" },
    { name: "دستبافت/ماشینی", type: "select", options: ["دستبافت", "ماشینی"] }
  ],
  147: [
    { name: "نوع", type: "select", options: ["پیراهن", "تی‌شرت", "کت", "شلوار", "لباس رسمی", "لباس راحتی"] },
    { name: "سایز", type: "text" },
    { name: "جنس", type: "text" },
    { name: "رنگ", type: "text" }
  ],
  152: [
    { name: "نوع", type: "text" },
    { name: "برند", type: "text" },
    { name: "تاریخ انقضا", type: "text" },
    { name: "وضعیت بسته‌بندی", type: "select", options: ["پلمپ", "باز شده"] }
  ],
  156: [
    { name: "نوع", type: "select", options: ["تکی", "دوقلو", "همراه با کریر"] },
    { name: "برند", type: "text" }
  ],
  175: [
    { name: "نوع", type: "select", options: ["دوچرخه", "اسکوتر", "اسکیت"] },
    { name: "مناسب برای", type: "select", options: ["بزرگسال", "کودک"] },
    { name: "برند", type: "text" },
    { name: "سایز چرخ", type: "text" }
  ],
  177: [
    { name: "نژاد", type: "text" },
    { name: "سن", type: "text" },
    { name: "واکسینه شده", type: "switch" },
    { name: "دارای شناسنامه", type: "switch" }
  ],
  184: [
    { name: "نژاد", type: "text" },
    { name: "سن", type: "text" },
    { name: "واکسینه شده", type: "switch" },
    { name: "دارای شناسنامه", type: "switch" }
  ],
  189: [
    { name: "نوع", type: "select", options: ["گیتار کلاسیک", "گیتار الکتریک", "بیس", "آمپلیفایر"] },
    { name: "برند", type: "text" }
  ],
  191: [
    { name: "نوع", type: "select", options: ["پیانو", "کیبورد", "آکاردئون"] },
    { name: "برند", type: "text" },
    { name: "تعداد کلاویه", type: "text" }
  ]
};
